import styled from "styled-components";

export const EditTravelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 35px 44px;
  background: #e5e5e5;
`;

export const UpperBlock = styled.div`
  align-self: flex-start;
`;

export const TitleWrapper = styled.p`
  padding: 0;
  margin: 0;
  font-weight: 700;
  font-size: 37px;
  line-height: 45px;
  color: gray;
`;

export const UserID = styled.span`
  font-weight: 700;
  font-size: 37px;
  line-height: 45px;
  text-transform: uppercase;
  color: #000000;
`;
